var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSer5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56 88a8 8 0 0 0 0-16H24a8 8 0 0 0 0 16h8v296h-8a8 8 0 0 0 0 16h32a8 8 0 0 0 0-16h-8V88ZM488 456h-8V32h8a8 8 0 0 0 0-16h-32a8 8 0 0 0 0 16h8v424h-8a8 8 0 0 0 0 16h32a8 8 0 0 0 0-16ZM384 448a8 8 0 0 0-8 8v8H136v-8a8 8 0 0 0-16 0v32a8 8 0 0 0 16 0v-8h240v8a8 8 0 0 0 16 0v-32a8 8 0 0 0-8-8Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 256,
    r: 8,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 320,
    r: 8,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.264 64.688-95.686-47.843A7.994 7.994 0 0 0 304 16h-96a7.994 7.994 0 0 0-3.578.845l-95.686 47.843c-3.253 1.365-10.014 5.966-16.164 21.341C84.229 106.885 80 139.847 80 184v192a8 8 0 0 0 8 8h45.636l-5.556 38.868a8 8 0 0 0 3.12 7.532c1.213.91 26.177 19.246 65.151 19.244a127.422 127.422 0 0 0 20.965-1.753A94.22 94.22 0 0 0 256 432.369a94.234 94.234 0 0 0 38.685 15.523 127.426 127.426 0 0 0 20.965 1.752c38.968 0 63.937-18.334 65.15-19.244a8 8 0 0 0 3.12-7.532L378.364 384H424a8 8 0 0 0 8-8V184c0-44.153-4.229-77.115-12.572-97.971-6.15-15.375-12.911-19.976-16.164-21.341Zm-89.92 27.75 12.619 18.928-72.827 84.034 53.357-154.146 24.7 34.582-13.723 4.574a8 8 0 0 0-4.126 12.028ZM312 151.908V152h24v16h-37.947ZM199.567 85.4a8 8 0 0 0-5.037-4.993l-13.724-4.574 24.7-34.582 42.027 121.413-5.993 17.316-55.614-68.452 12.729-19.093a8 8 0 0 0 .912-7.035ZM256 138.211 230.312 64h51.376ZM287.227 48h-62.454l-5.538-16h73.53ZM96 368V184c0-55.106 6.832-81.708 12.37-94.223l43.483 166.685L135.922 368Zm64.083-56H192v16h-34.2Zm54.6 120.108a106.121 106.121 0 0 1-70.038-12.068L155.512 344H200a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8h-37.632l5.552-38.869a8.029 8.029 0 0 0-.179-3.151L121.378 76.255 182.77 45.56l-21.28 29.791a8 8 0 0 0 3.98 12.239l14.063 4.687-10.189 15.285a8 8 0 0 0 .447 9.483l65.59 80.731-10.941 31.607A7.984 7.984 0 0 0 224 232v160a8.007 8.007 0 0 0 .572 2.972c.256.638 5.535 13.559 18.611 26.657a79.1 79.1 0 0 1-28.498 10.479Zm82.631 0A77.865 77.865 0 0 1 261 416.145a78.1 78.1 0 0 1-21-25.864V234.984L284.187 184H344a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8h-18.213l16.259-18.761a8 8 0 0 0 .61-9.677l-10.189-15.285 14.063-4.687a8 8 0 0 0 3.98-12.24l-21.278-29.79 61.39 30.695-46.363 177.725a8.034 8.034 0 0 0-.179 3.152L349.633 296H312a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h44.49l10.866 76.065c-9.356 5.506-35.113 17.86-70.04 12.044ZM354.2 328H320v-16h31.918Zm61.8 40h-39.919l-15.934-111.538L403.63 89.777C409.168 102.292 416 128.894 416 184Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSer5);
export default __webpack_public_path__ + "static/media/ser-5.3269cffca91398a80fe8a83aad3194ed.svg";
export { ForwardRef as ReactComponent };